<template>
  <a-layout class="spo-layout-wrap">
    <div
      v-if="device === 'mobile' && !collapse"
      class="spo-mask"
      @click="handleFoldSideBar"
    ></div>
    <a-layout-sider
      collapsible
      :collapsedWidth="0"
      class="spo-sider"
      :width="device === 'mobile' ? '250px' : '17.857vw'"
      v-model:collapsed="collapse"
      :class="classObj"
      :trigger="null"
    >
      <div class="menu-header">
        <h2 class="title">Navigation</h2>
        <a-button type="link" @click="localRefresh()">
          <template #icon><RedoOutlined /></template>
        </a-button>
      </div>

      <div class="menu-in-box">
        <spo-menu v-if="routers.length" :routers="routers"></spo-menu>
      </div>
    </a-layout-sider>

    <a-layout
      class="spo-layout"
      :class="'mobile' === device ? 'spo-mobile-layout' : ''"
    >
      <div class="spo-header">
        <a-row>
          <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <spo-logo />
          </a-col>
          <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <span v-if="device !== 'mobile'" style="padding-right: 15px">
              Powered by GE Healthcare
            </span>

            <spo-avatar />
          </a-col>
        </a-row>
      </div>
      <spo-content />
    </a-layout>
  </a-layout>
</template>
<script>
  import SpoLogo from './spo-logo'
  import SpoAvatar from './spo-avatar'
  import SpoMenu from './spo-menu'
  import SpoContent from './spo-content'
  import { mapActions, mapGetters } from 'vuex'
  import { RedoOutlined } from '@ant-design/icons-vue'

  export default {
    components: {
      SpoLogo,
      SpoAvatar,
      SpoMenu,
      SpoContent,
      RedoOutlined,
    },
    data() {
      return {
        selectedKeys: [],
        openKeys: [],
      }
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        routes: 'routes/routes',
        device: 'settings/device',
        menuList: 'routes/menu',
      }),
      routers() {
        return this.menuList
      },
      classObj() {
        return {
          'spo-mobile': this.device === 'mobile',
          'spo-collapse': this.collapse,
        }
      },
    },

    beforeMount() {
      window.addEventListener('resize', this.handleLayouts)
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleLayouts)
    },
    mounted() {
      this.handleLayouts()
    },
    methods: {
      ...mapActions({
        toggleDevice: 'settings/toggleDevice',
        handleFoldSideBar: 'settings/foldSideBar',
        toggleCollapse: 'settings/toggleCollapse',
      }),
      handleLayouts() {
        const width = document.body.getBoundingClientRect().width
        if (this.width !== width) {
          const isMobile = width - 1 < 992
          this.toggleDevice(isMobile ? 'mobile' : 'desktop')
          this.width = width
        }
      },
      localRefresh() {
        location.reload()
      },
    },
  }
</script>
<style lang="less">
  @header-height: 32px;
  @import '~@/styles/variables.less';
  .spo-layout-wrap {
    .spo-sider {
      position: fixed;
      left: 0;
      height: 100vh;
      overflow: hidden;
      background: #efefef;
      z-index: 1000;
    }
    .menu-header {
      background: #e4e6e7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      border-bottom: 1px solid #ddd;
      h2 {
        font-size: 18px;
        margin: 0;
        padding: 0;
      }
    }

    .spo-layout {
      padding-left: 250px;
      transition: all 0.2s;
    }
    .spo-mobile-layout {
      padding-left: 0;
      transition: all 0.2s;
    }
    .spo-collapse {
      .spo-logo .anticon + span {
        display: inline-block;
        max-width: 0;
        opacity: 0;
        transition: all 0.2s;
      }
      & + .spo-layout {
        padding-left: 0;
        transition: all 0.2s;
      }
    }
    .spo-mask {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 998;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background: #000;
      opacity: 0.5;
    }
    .spo-mobile {
      position: fixed !important;
      z-index: 999;
      &.spo-collapse {
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        * {
          display: none !important;
          width: 0 !important;
          min-width: 0 !important;
          max-width: 0 !important;
        }
        .ant-menu-item,
        .ant-menu-submenu {
          display: none !important;
          width: 0 !important;
          min-width: 0 !important;
          max-width: 0 !important;
        }
        & + .spo-layout {
          padding-left: 0px !important;
          transition: all 0.2s;
        }
      }
    }
    .spo-header {
      padding: 0;
      background: @master;
      color: rgba(255, 255, 255, 0.4);
      img {
        height: 12px;
        vertical-align: middle;
        margin: 0 10px 0 5px;
      }
      .ant-col + .ant-col {
        display: flex;
        justify-content: flex-end;
        padding: 0 @spo-padding;
        align-items: center;
      }
      .trigger {
        height: @header-height;
        padding: 0 @spo-padding;
        font-size: 18px;
        line-height: @header-height;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          color: @primary-color;
        }
      }
    }
    .menu-in-box {
      height: calc(100vh - @header-height);
      overflow-y: auto;
      background: #efefef;
      &::-webkit-scrollbar-track-piece {
        background-color: transparent;
      }
      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: hsla(0, 0%, 0%, 0.1);
      }
    }
  }
  @media screen and (max-width: 720px) {
    .spo-layout-wrap {
      .spo-sider {
        height: 100vh;
        .anticon {
          font-size: 12px;
        }
      }
      .menu-header {
        padding: 5px 10px;

        h2 {
          font-size: 18px;
        }
      }

      .spo-layout {
        padding-left: 0px;
      }

      .spo-header {
        img {
          height: 12px;

          margin: 0 10px 0 5px;
        }
        .ant-col + .ant-col {
          padding: 0 10px;
        }
        .trigger {
          height: @header-height;
          padding: 0 @spo-padding;
          font-size: 18px;
          line-height: @header-height;
        }
      }
      .menu-in-box {
        height: calc(100vh - @header-height);

        &::-webkit-scrollbar {
          width: 7px;
          height: 7px;
        }
      }
    }
  }
</style>
